module.exports = __webpack_public_path__ + "static/img/044 3.18b3aaa2.jpg";